import React, { useState } from 'react';
import slice from 'lodash/slice';
import { scroller, Element } from 'react-scroll';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import LoadMore from 'components/loadMore';
import { HEADER_HEIGHT } from 'config';
import { useInstagramPosts } from 'context/socialFeed';

import {
  socialMediaFeeds,
  imageContainer,
  loadMore,
} from './scss/SocialMediaFeeds.module.scss';
import { POSTS_PER_PAGE } from './SocialMediaFeeds.constants';

const SocialMediaFeeds = () => {
  const instagramPosts = useInstagramPosts();
  const [pageNumber, setPageNumber] = useState(1);
  const loadMorePosts = () => {
    setPageNumber(pageNumber + 1);
    scroller.scrollTo('loadMore', {
      smooth: true,
      offset: 30 - HEADER_HEIGHT,
    });
  };
  const collapsePosts = () => {
    scroller.scrollTo('socialFeedsWrapper', {
      smooth: true,
      offset: -100,
      duration: 600,
    });
    setTimeout(() => {
      setPageNumber(1);
    }, 600);
  };
  const loadedPostsCount = pageNumber * POSTS_PER_PAGE;
  const canLoadMore =
    instagramPosts.length && loadedPostsCount < instagramPosts.length;

  return (
    <div name="socialFeedsWrapper">
      <div className={socialMediaFeeds}>
        {slice(instagramPosts, 0, loadedPostsCount).map(
          ({ image, carouselMedia }, index) => {
            return (
              <div className={imageContainer} key={`social-image-${index}`}>
                <div />
                <LazyLoadImage
                  effect="blur"
                  src={image.standard_resolution.url}
                  sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                  srcSet={`
                      ${image.low_resolution.url} ${image.low_resolution.width}w,
                      ${image.standard_resolution.url} ${image.standard_resolution.width}w,
                    `}
                  alt="Afex Nigeria"
                />
              </div>
            );
          }
        )}
      </div>
      <Element name="loadMore">
        <LoadMore
          isVisible={instagramPosts.length > POSTS_PER_PAGE}
          label={canLoadMore ? 'Load more' : 'Collapse Posts'}
          onClick={canLoadMore ? loadMorePosts : collapsePosts}
          arrowDirection={canLoadMore ? 'down' : 'up'}
          className={loadMore}
        />
      </Element>
    </div>
  );
};

SocialMediaFeeds.propTypes = {};

SocialMediaFeeds.defaultProps = {};

export default SocialMediaFeeds;
